import { gorgiasSrc } from 'components/scripts/gorgias';
import { Spinner } from 'components/shared/icons/ui';
import Head from 'next/head';
import Script from 'next/script';
import { useEffect, useState } from 'react';

export default () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!done) {
      setIsLoading(true);
      const timeout = setTimeout(() => setError(true), 10 * 1000);
      return () => clearTimeout(timeout);
    }
    setIsLoading(false);
    setError(false);

    return () => {};
  }, [done]);

  return (
    <>
      <Head>
        <title>Support</title>
      </Head>
      <main
        className={`flex min-h-screen flex-col items-center justify-center p-12 text-center transition-opacity delay-[3s] duration-500 ${
          isLoading || error ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <div className="flex flex-col items-center gap-2">
          {error ? (
            <>
              <h1 className="font-nimbus-sans-extd-d text-[20px] font-bold uppercase leading-[0.9] md:text-[35px]">
                Our bad... something went wrong
              </h1>
              <p className="text-[15px]">Please try again later.</p>
            </>
          ) : (
            <Spinner className="w-6" />
          )}
        </div>
      </main>
      <style>
        {`
      #gorgias-chat-container iframe#chat-button{
        display: none !important;
      }
    `}
      </style>
      {/* Overlap close button */}
      <div
        className={`delay-0 fixed top-4 right-4 z-[9999999999] block h-12 w-12 transition-all delay-[50ms] duration-[250ms] ease-in-out md:hidden ${
          done ? 'translate-y-0 bg-[#666665]' : 'translate-y-3 bg-transparent'
        }`}
      />
      <Script
        id="gorgias-chat-widget-install-v2"
        strategy="lazyOnload"
        src={gorgiasSrc}
        onLoad={() => {
          const { GorgiasChat } = window;
          GorgiasChat.init().then(c => {
            setDone(true);
            c.hidePoweredBy(true);
            c.open();
          });
        }}
      />
    </>
  );
};
